<!--  -->
<template>
  <div class="Header">
    <div class="left">
      <img src="../assets/logo.png" class="w-[24px] h-[24px] mr-2" />
      炽坤
    </div>
    <div class="flex items-center">
      <div
        class="flex items-center justify-end pr-2 cursor-pointer pl-[20px] h-[40px] rounded-[6px] relative head-name z-30"
      >
        <el-image
          fit="cover"
          class="w-[24px] h-[24px] rounded-[4px] mr-[4px]"
          :src="avatar"
        />
        {{ name }}<i class="el-icon-arrow-down text-[12px] ml-[5px]"></i>
        <div
          class="down absolute z-30 rounded-[4px] top-[40px] right-0 bg-white w-[89px] grid grid-rows-2 text-center leading-[48px] hidden"
        >
          <div class="down-item" @click="$router.push({ path: '/' })">首页</div>
          <div class="down-item" @click="logout">退出登录</div>
          <div
            class="down-item"
            @click="$router.push({ path: '/detail/updatePwd' })"
          >
            修改密码
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters(["name", "avatar"]),
  },
  data() {
    return {};
  },
  created() {},
  async mounted() {},

  methods: {
    async logout() {
      this.$confirm("确定退出系统吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("LogOut").then(() => {
            location.href = `/#/login?redirect=${this.$route.path}`;
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang="scss">
.Header {
  background-color: #fff;
  height: 48px;
  padding: 0 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-items: center;
    .logo {
      height: 24px;
    }
    .name {
      border-radius: 4px;
      background: #f7f7f7;
      border: 1px solid #dfdfdf;
      font-size: 10px;
      padding: 2px;
      line-height: 12px;
      margin-left: 4px;
    }
  }
  .head-name:hover {
    background-color: #f4f4f4;
    .down {
      display: block;
    }
  }
  .down {
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.12);
  }
  .down-item:hover,
  .notice:hover {
    background-color: #f4f4f4;
  }
  :deep(.el-badge) {
    .el-badge__content.is-fixed {
      top: 7px;
      right: 25px;
    }
  }
}
</style>
